// SAVE ORDER *************************************************************************************
// pathname: /v1/order/save-order/${shoppingCartId}
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';
import { bjToast } from '@components/common';

/**
 * @description Hook interface.
 */
interface UseSwrSaveOrderProps {
  locale: string,
  shoppingCartId?: number | string,
  successCallback?: (response: ApiSchema<'CartOrderResponse'>) => Promise<void> | void,
  errorCallback?: () => void,
}

/**
 * @description Hook to save order.
 * - `locale` - the Locale.
 * - `shoppingCartId` - the shopping cart id.
 * - `successCallback` - function to execute on succes.
 * - `errorCallback` - function to execute on error.
 */
export const useSwrCreateOrderCandidate = (props: UseSwrSaveOrderProps) => {
  // Destructure props
  const {
    locale,
    successCallback,
    errorCallback,
  } = props;

  // SWR: fetch data
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiSchema<'CartOrderResponse'>, ApiSchema<'UserOrderRequest'>>({
    url: '/v1/user-order/create',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: (response) => {
        if (successCallback) { void successCallback(response); }
      },
      onError: (newError) => {
        if (newError?.errors[0]?.code === 861) {
          bjToast.error(newError.errors[0].message);
        } else if (errorCallback) errorCallback();
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
